import { createStore } from "vuex";

const store = createStore({
  state: {
    user: {},

    statusNavbar: false,
    ModalCancel: {
      rrimEdit: false,
      rrimView: false,
      layout_extracao: false,
      itemChecklist: false,
    },
    DataImages: {
      AberturaEmbalagem: {},
      MoldeFechado: {},
      MoldeAberto: {},
      CAF: {},
    },
    DataImagesLSP: [],
    DataImageIG: {},
    // ImgURL: "http://localhost:3333/static/",
    ImgURL: "https://apirrimjpa.tutilabs.com.br/static/",
    DataAllRRIM: {},
    emitData: {
      produtos: [],
      checklist: [],
    },
    listLayout: [],
    listItems: [],
    loading: false,
    loadingPattern: false,
    loadingPatternProgress: {
      status: false,
      progress: 0,
      total: 0,
      loading: 0,
    },
    table: false,
    approved: false,
    rejected: false,
    homologation: false,
    hiddenBar: false,
    removeicons: false,
    formPage: 0,
    formState: 0,
    paddingValue: "2rem",
  },

  mutations: {
    MutationImagesAberturaEmbalagem(state, payload) {
      state.DataImages.AberturaEmbalagem = payload;
    },
    MutationImagesMoldeFechado(state, payload) {
      state.DataImages.MoldeFechado = payload;
    },
    MutationImagesMoldeAberto(state, payload) {
      state.DataImages.MoldeAberto = payload;
    },
    MutationImagesLSP(state, payload) {
      state.DataImagesLSP = payload;
    },

    MutationImageInfoGeral(state, payload) {
      state.DataImageIG = payload;
    },
    MutationCAF(state, payload) {
      state.DataImages.CAF = payload;
    },

    MutationGetFindDataRRIM(state, payload) {
      state.DataAllRRIM = payload;
    },

    MutationSetDataChecklistUpdate(state, payload) {
      state.emitData.checklist = payload;
    },

    MutationSetDataProdutosUpdate(state, payload) {
      state.emitData.produtos = payload;
    },

    MutationSetSatatusNavBar(state, payload) {
      state.statusNavbar = payload;
    },
    MutationSetCancelModalEditRRIM(state, payload) {
      state.ModalCancel.rrimEdit = payload;
    },

    MutationSetCancelModalViewRRIM(state, payload) {
      state.ModalCancel.rrimView = payload;
    },

    MutationSetCancelModalLayoutExtra(state, payload) {
      state.ModalCancel.layout_extracao = payload;
    },

    MutationSetCancelModaItemCheckllist(state, payload) {
      state.ModalCancel.itemChecklist = payload;
    },
    SetUsers(state, payload) {
      state.user = payload.user;
    },
    SetListLayout(state, payload) {
      state.listLayout = [];
      state.listLayout = payload;
    },
    SetListItems(state, payload) {
      state.listItems = [];
      state.listItems = payload;
    },
    SetLoading(state, payload) {
      state.loading = payload;
    },

    SetLoadingPattern(state, payload) {
      state.loadingPattern = payload;
    },

    SetLoadingPatternProgress(state, payload) {
      state.loadingPatternProgress = payload;
    },
    SET_APPROVED(state) {
      state.table = false;
      state.approved = true;
      state.rejected = false;
      state.homologation = false;
    },
    SET_REJECTED(state) {
      state.table = false;
      state.approved = false;
      state.rejected = true;
      state.homologation = false;
    },
    SET_HOMOLOGATION(state) {
      state.table = false;
      state.approved = false;
      state.rejected = false;
      state.homologation = true;
    },
    setHiddenBar(state, value) {
      state.hiddenBar = value;
    },
    setIcon(state, value) {
      state.removeicons = value;
    },
    setPage(state, value) {
      state.formPage = value;
    },
    increment(state) {
      if (typeof state.formPage === "number") {
        state.formPage++;
      } else {
        state.formPage = 0;
      }
    },
    decrement(state) {
      if (typeof state.formPage === "number") {
        state.formPage--;
      } else {
        state.formPage = 0;
      }
    },
    SetFormPage(state, value) {
      state.formPage = value;
    },
    setPadding(state, value) {
      state.paddingValue = value;
    },
  },
  actions: {
    SetApproved({ commit }, payload) {
      commit("toggleApproved");
    },

    SetImagesAberturaEmbalagem(context, payload) {
      context.commit("MutationImagesAberturaEmbalagem", payload);
    },

    SetImagesMoldeAberto(context, payload) {
      context.commit("MutationImagesMoldeAberto", payload);
    },

    SetImagesMoldeFechado(context, payload) {
      context.commit("MutationImagesMoldeFechado", payload);
    },
    SetImagesLSP(context, payload) {
      context.commit("MutationImagesLSP", payload);
    },
    ToggleApprovedAction({ commit }) {
      commit("toggleApproved");
    },
    updatePadding({ commit }, value) {
      commit("setPadding", value);
    },
  },
  getters: {
    getApproved(state) {
      return state.cardGreen;
    },
    GetCAF(state) {
      return state.DataImages.CAF;
    },
    $GetDataImages(state) {
      return state.DataImages;
    },
    $GetImagesLSP(state) {
      return state.DataImagesLSP;
    },
    async $GetDataAllRRIM(state) {
      return state.DataAllRRIM;
    },
    $GetDataEmitsUpdate(state) {
      return state.emitData;
    },
    $GetStatusNavBar(state) {
      return state.statusNavbar;
    },
    $GetModalCancel(state) {
      return state.ModalCancel;
    },

    get_users(state) {
      return state.user;
    },

    getApproved(state) {
      return state.approved;
    },
    getPadding: (state) => state.paddingValue,
  },
});

export { store };
